<template>
  <v-flex xs12>
    <operations-grid
      ref="operationsGrid"
      :deal-model="dealModel"
      :is-read-only="isReadOnly"
      :editable="editable"
      :has-orders="hasOrders"
      @save-operation="saveOperation"
      :deal-type-id="dealTypeId"
      :marketId="marketId"
    />
  </v-flex>
</template>

<script>
import OperationsGrid from './OperationsGrid'

export default {
  props: {
    isReadOnly: {type: Boolean, required: true},
    editable: {type: Boolean, required: true},
    dealModel: {type: Object, required: true},
    dealTypeId: {type: Number, required: true},
    hasOrders: {type: Boolean, required: true},
    marketId: {type: Number, required: true},
  },
  methods: {
    isEmpty() {
      return this.$refs.operationsGrid.isEmpty()
    },
    async validate() {
      const validation = this.$refs.operationsGrid.validate()
      if (validation.length) {
        return validation
      }

      return []
    },
    saveOperation() {
      this.$emit('save-operation')
    },
    cancelChanges() {
      this.$refs.operationsGrid.cancelGridChanges()
    },
  },
  components: {
    OperationsGrid,
  },
}
</script>
